// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1URYV","errorLogs":"EditorFooter_errorLogs__1QRq3"};